module.exports = __webpack_public_path__ + "img/top.87edffb0.jpg";